// Event types for investor activity logging
export const InvestorActivityEventType = {
  // Authentication events
  LOGIN: "login",
  VERIFY_LOGIN: "verifyLogin",
  GOOGLE_LOGIN: "googleLogin",
  RESEND_OTP: "resendOtp",
  
  // User profile events
  PERSONAL_DETAILS_SAVED: "personalDetailsSaved",
  AADHAR_OTP_SENT: "aadharOtpSent",
  AADHAR_OTP_VERIFIED: "aadharOtpVerified",
  PAN_AND_BANK_VERIFIED: "panAndBankVerified",
  PAN_AND_BANK_SUBMITTED: "panAndBankSubmitted",
  MANUAL_KYC_SUBMITTED: "manualKycSubmitted",
  USER_AGREEMENT: "userAgreement",
  
  // DLT Account events
  INVESTOR_DLT_ACCOUNT_CREATED: "investorDltAccountCreated",
  INVESTOR_DLT_KEY_DOWNLOADED: "investorDltKeyDownloaded",
  TRUST_DLT_ACCOUNT_CREATED: "trustDltAccountCreated",
  TRUST_DLT_KEY_DOWNLOADED: "trustDltKeyDownloaded",
  HUF_DLT_ACCOUNT_CREATED: "hufDltAccountCreated",
  HUF_DLT_KEY_DOWNLOADED: "hufDltKeyDownloaded",
  
  // Family member events
  FAMILY_MEMBER_PERSONAL_DETAILS_SAVED: "familyMemberPersonalDetailsSaved",
  FAMILY_MEMBER_AADHAR_OTP_SENT: "familyMemberAadharOtpSent",
  FAMILY_MEMBER_AADHAR_OTP_VERIFIED: "familyMemberAadharOtpVerified",
  FAMILY_MEMBER_PAN_VERIFIED: "familyMemberPanVerified",
  FAMILY_MEMBER_MANUAL_KYC_SUBMITTED: "familyMemberManualKycSubmitted",
  FAMILY_MEMBER_DLT_ACCOUNT_CREATED: "familymemberDltAccountCreated",
  FAMILY_MEMBER_DLT_KEY_DOWNLOADED: "familyMemberDltKeyDownloaded",
  
  // Registration events
  TRUST_REGISTRATION_SUBMITTED: "trustRegistrationSubmitted",
  HUF_REGISTRATION_SUBMITTED: "hufRegistrationSubmitted",
  
  // Property and project events
  ASSET_VISITED: "assetVisited",
  PROJECT_VISITED: "projectVisited",
  INVEST_NOW_CLICKED: "investNowClicked",
  
  // Transaction events
  COMMITMENT_CREATED: "commitmentCreated",
  PAYMENT_REQUEST_MADE: "paymentRequestMade",
  PAYMENT_SUCCESSFUL: "paymentSuccessful",
  COMMITMENT_CANCELLED: "commitmentCancelled",
  WALLET_PAYMENT_SUCCESSFUL: "walletPaymentSuccessful",
  // Navigation events
  PORTFOLIO_VIEWED: "portfolioViewed",
  TRANSACTION_PAGE_VIEWED: "transactionPageViewed",
  PROFILE_VIEWED: "profileViewed",

  // Wallet events
  WALLET_PAGE_VIEWED: "walletPageViewed" ,
  ADD_FUNDS_CLICKED: "addFundsClicked",
  BANK_DEPOSIT_INITIATED: "bankDepositInitiated",
  GATEWAY_DEPOSIT_SUCCESSFUL: "gatewayDepositSuccessful",
  WITHDRAWAL_INITIATED: "withdrawalInitiated",  


  // Sharing & referral events
  GO_TO_ASSET_CLICKED: "goToAssetClicked",
  SHARE_LINK_COPIED: "shareLinkCopied",
  WHATSAPP_INVITE_SHARED: "whatsappInviteShared",
  EMAIL_INVITE_SHARED: "emailInviteShared",
  INVITE_VIEW_DETAILS_CLICKED: "inviteViewDetailsClicked",
};

export default InvestorActivityEventType;

